import { Target, Layers, Film, TrendingUp, Search } from "lucide-react";
import { SERVICES } from "@/lib/siteData";

const iconMap = {
  "paid-ads": Target,
  funnels: Layers,
  content: Film,
  social: TrendingUp,
  seo: Search,
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-[#1E2A1E]/30"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-3xl">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#E3A21A] mb-4">
              What We Do
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] font-medium">
              Revenue systems,
              <br />
              <span className="text-[#E3A21A] italic font-light">not campaigns.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#A8B8A8] text-base leading-relaxed">
            Five interconnected capabilities. Deployed as one system, tuned to your
            business math.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = iconMap[s.id];
            const featured = i === 0;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative rounded-2xl border overflow-hidden p-8 md:p-10 transition-all duration-500 hover:-translate-y-1 ${
                  featured
                    ? "bg-[#E3A21A] text-[#121A12] border-[#E3A21A] md:row-span-2"
                    : "bg-[#1E2A1E] border-[#E3A21A]/10 hover:border-[#E3A21A]/40"
                }`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div
                    className={`h-14 w-14 rounded-xl flex items-center justify-center ${
                      featured
                        ? "bg-[#121A12] text-[#E3A21A]"
                        : "bg-[#121A12] text-[#E3A21A] border border-[#E3A21A]/20"
                    }`}
                  >
                    {Icon ? <Icon className="h-6 w-6" /> : null}
                  </div>
                  <div
                    className={`font-mono text-xs tracking-wider ${
                      featured ? "text-[#121A12]/60" : "text-[#A8B8A8]"
                    }`}
                  >
                    {s.number}
                  </div>
                </div>

                <h3
                  className={`font-display text-2xl md:text-3xl tracking-tight font-medium ${
                    featured ? "text-[#121A12]" : "text-[#F5F5F0]"
                  }`}
                >
                  {s.name}
                </h3>
                <p
                  className={`mt-2 text-sm ${
                    featured ? "text-[#121A12]/70" : "text-[#A8B8A8]"
                  }`}
                >
                  {s.subtitle}
                </p>

                <ul
                  className={`mt-6 space-y-2 text-sm ${
                    featured ? "text-[#121A12]/85" : "text-[#F5F5F0]/85"
                  }`}
                >
                  {s.points.map((p, idx) => (
                    <li key={idx} className="flex items-start gap-2.5">
                      <span
                        className={`mt-2 block h-1 w-1 rounded-full ${
                          featured ? "bg-[#121A12]" : "bg-[#E3A21A]"
                        }`}
                      />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>

                <div
                  className={`mt-8 pt-5 border-t flex items-center gap-2 ${
                    featured ? "border-[#121A12]/20" : "border-[#E3A21A]/15"
                  }`}
                >
                  <span
                    className={`text-[10px] tracking-[0.25em] uppercase font-bold ${
                      featured ? "text-[#121A12]" : "text-[#E3A21A]"
                    }`}
                  >
                    Result
                  </span>
                  <span
                    className={`text-sm font-medium ${
                      featured ? "text-[#121A12]" : "text-[#F5F5F0]"
                    }`}
                  >
                    → {s.result}
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
